<!-- components/ScrollSwipe.vue -->
<template>
  <van-swipe
      lazy-render
      ref="swipeRef"
      vertical
      :loop="false"
      :style="{ height: height + 'px' ,width:'100%'}"
      :show-indicators="false"
      @change="swiperChange"
  >
    <van-swipe-item
        v-for="(pageData, pageIndex) in data"
        :key="pageIndex"
    >
      <div
          class="scroll-container"
          :style="{ height: height + 'px' }"
          :ref="el => setScrollRef(el, pageIndex)"
          @touchstart="onTouchStart($event)"
          @touchmove="onTouchMove($event, pageIndex)"
      >
        <slot :items="pageData" :page-index="pageIndex" />
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script setup>
  import { ref } from 'vue'
  defineExpose({
    changeSwiperPage
  })
  const props = defineProps({
    data: {
      type: Array, // 二维数组
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    onSwipeChange: Function,
    // 切换分栏时是否把对应右侧内容重置回顶部(默认 false, 保持原有行为)
    resetTopOnChange: {
      type: Boolean,
      default: false,
    },
  })

  function swiperChange(index){
    currentPageIndex.value = index;
    if(props.onSwipeChange){
      props.onSwipeChange(index);
    }
  }

  const scrollRefs = ref([])
  const touchStartY = ref(0)
  const swipeRef = ref();

  const scrollPositionY = ref(0) // ✨ 新增：記錄每頁的 scrollTop
  const currentPageIndex = ref(0) // ✨ 新增：當前所在的 pageIndex

  onActivated(()=>{
    resetScrollPosition(currentPageIndex.value)
  });
  function resetScrollPosition(index) {
    nextTick(() => {
      const el = scrollRefs.value[index]
      if (el) {
        el.scrollTop = scrollPositionY.value || 0
      }
    })
  }
  function changeSwiperPage(index) {
    swipeRef.value.swipeTo(index);
    // 仅手动点击左侧大类切换时, 让该分栏右侧内容回到顶部(上滑/下滑手势翻页不触发)
    if (props.resetTopOnChange) {
      scrollPositionY.value = 0;
      nextTick(() => {
        const el = scrollRefs.value[index];
        if (el) el.scrollTop = 0;
      });
    }
  }

  function setScrollRef(el, index) {
    if (el) {
      scrollRefs.value[index] = el;

      el.onscroll = () => {
        scrollPositionY.value = el.scrollTop
      }
    }
  }

  function onTouchStart(e) {
    touchStartY.value = e.touches[0].clientY
  }

  function onTouchMove(e, index) {
    const currentY = e.touches[0].clientY
    const deltaY = currentY - touchStartY.value
    const scrollEl = scrollRefs.value[index]
    if (!scrollEl) return

    const { scrollTop, scrollHeight, clientHeight } = scrollEl
    const isAtTop = scrollTop === 0
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1

    if (
        (deltaY > 0 && !isAtTop) || // 向下但不是顶部
        (deltaY < 0 && !isAtBottom) // 向上但不是底部
    ) {
      e.stopPropagation()
    }
  }
</script>

<style scoped>
  .scroll-container {
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  .scroll-container::-webkit-scrollbar {
    display: none;
  }
</style>
